<template>
  <div class="wordcloud-host">
    <div ref="container" class="wordcloud"></div>
    <div
      v-show="tooltip.show"
      class="wc-tooltip"
      :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }"
    >
      <span class="wc-tooltip-text">{{ tooltip.text }}</span>
      <span class="wc-tooltip-value">{{ tooltip.value }}</span>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import cloud from "d3-cloud"

export default {
  name: "WordCloud",

  props: {
    words: {
      type: Array,
      required: true
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 300
    },
    maxWords: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      tooltip: { show: false, x: 0, y: 0, text: "", value: 0 }
    }
  },
mounted() {
    this.render()
  },

  watch: {
    words: {
      handler() {
        this.render()
      },
      deep: true
    }
  },

  methods: {
    render() {
      if (!this.$refs.container) return
      
      d3.select(this.$refs.container).selectAll("*").remove()

      if (!this.words || !this.words.length) return

      const data = [...this.words]
        .sort((a, b) => b.value - a.value)
        .slice(0, this.maxWords)

      const sizeScale = d3.scaleSqrt()
        .domain(d3.extent(data, d => d.value))
        .range([14, 48])

      const colorScale = d3.scaleLinear()
        .domain(d3.extent(data, d => d.value))
        .range(["#94a3b8", "#1e3a8a"])

      const layout = cloud()
        .size([this.width, this.height])
        .words(data.map(d => ({ ...d })))
        .padding(4)
        .rotate(() => 0)
        .font("Inter, system-ui, sans-serif")
        .fontSize(d => sizeScale(d.value))
        .on("end", words => this.draw(words, colorScale))

      layout.start()
    },

    draw(words, colorScale) {
      const svg = d3.select(this.$refs.container)
        .append("svg")
        .attr("width", this.width)
        .attr("height", this.height)

      const group = svg.append("g")
        .attr(
          "transform",
          `translate(${this.width / 2}, ${this.height / 2})`
        )

      const host = this.$refs.container
      const showTooltip = (event, d) => {
        const rect = host.getBoundingClientRect()
        this.tooltip = {
          show: true,
          x: event.clientX - rect.left + 12,
          y: event.clientY - rect.top + 12,
          text: d.text.replace(/_/g, " "),
          value: d.value,
        }
      }
      const moveTooltip = (event) => {
        const rect = host.getBoundingClientRect()
        this.tooltip.x = event.clientX - rect.left + 12
        this.tooltip.y = event.clientY - rect.top + 12
      }
      const hideTooltip = () => {
        this.tooltip.show = false
      }

      group.selectAll("text")
        .data(words)
        .enter()
        .append("text")
        .style("font-size", d => `${d.size}px`)
        .style("font-family", d => d.font)
        .style("fill", d => colorScale(d.value))
        .attr("text-anchor", "middle")
        .attr("transform", d => `translate(${d.x}, ${d.y})`)
        .text(d => d.text.replace(/_/g, " "))
        .style("cursor", "pointer")
        .on("click", (_, d) => {
          this.$emit("word-click", d)
        })
        .on("mouseover", showTooltip)
        .on("mousemove", moveTooltip)
        .on("mouseout", hideTooltip)
    }
  }
}
</script>

<style scoped>
.wordcloud-host {
  position: relative;
  width: 100%;
}
.wordcloud {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wc-tooltip {
  position: absolute;
  pointer-events: none;
  background: rgba(17, 24, 39, 0.92);
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.2;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  z-index: 10;
  display: flex;
  gap: 8px;
  align-items: center;
}
.wc-tooltip-text {
  font-weight: 500;
}
.wc-tooltip-value {
  background: #D972A3;
  color: #fff;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/results/ResultsCloud.vue